import { NodeLinkWrapper } from './wrapper';
import { NetworkGraphKnobs } from './nodeGraphKnobs';
import { PropertyType as SrsPropertyType, PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { nodeGraph } from 'widgets/endpoints';
import { filterProperties } from 'utilities/srsUtils';

const flags = [SrsPropertyFlag.Categorical];
const types = [SrsPropertyType.String];

export const config = {
	key: 'NETWORK_GRAPH',
	label: 'Node-based Graph',
	icon: 'graph',
	wrapper: NodeLinkWrapper,
	endpoint: nodeGraph,
	Knobs: NetworkGraphKnobs,
	flags: flags,
	types: types,
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name, filteredProperties[1].name],
				parameters: {
					maxNodes: 1000,
					minConnections: 1,
					metadata: [],
				},
			},
		};
	},
	createDefaultConfiguration: () => {
		return {
			sizeByConnection: false,
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, flags, types).length >= 2;
	},
};
